import {
    ACTION_GET_MENU_USER_COMPANY,
    SET_MENU_USER_COMPANY
} from "@/shared/components/menu_user_company/store/types/types.js";

import { MenuUserCompanyService } from "@/services";
import i18n from '@/plugins/i18n';

const actions = {

    [ACTION_GET_MENU_USER_COMPANY]: async ({ state, commit } ) => {
        return new Promise((resolve, reject) => {
            const idGroup = sessionStorage.getItem("idGroup");
            const idEmpresa = sessionStorage.getItem("idEmpresa");
            const idUsuario = sessionStorage.getItem("idUsuario");

            try {
                state.loading = true;

                MenuUserCompanyService.getMenuUserCompany(idGroup, idEmpresa, idUsuario)
                .then(resp => {
                    const products = resp.data.payload
                    commit(SET_MENU_USER_COMPANY, products);
                    resolve(resp.data.payload); 
                   
                })
                .catch(err => {
                    console.error(i18n.t('label.actionErrorRequest'), err);
                    reject(err);
                })
                .finally(() => {
                    state.loading = false;
                });
            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

   

};

export default actions;
